<div class="payments-methods-logo-list-wrapper">
    <img src="./../../../../assets/images/payment-methods/mastercard.svg" alt="mastercard">
    <img src="./../../../../assets/images/payment-methods/visa.svg" alt="visa">
    <!--
        <img src="./../../../../assets/images/payment-methods/apple-pay.svg" alt="apple_pay">
    <img src="./../../../../assets/images/payment-methods/google-pay.svg" alt="google_pay">
    -->
</div>